<footer class="footer bg-dark text-white py-3" [hidden]="hideFooter">
   <div class="container-fluid px-4">
      <div class="d-flex justify-content-between align-items-center position-relative">
         <small>&copy; {{currentYear}} Southwestern Advantage</small>
         @if (clientVersion(); as version) {
            <small class="text-white-50 position-absolute top-50 start-50 translate-middle">v{{ version }}</small>
         }
         <small><a href="https://southwestern.com/privacy-notice/" class="text-white"
                   target="_blank">Privacy</a> •
                <a href="https://southwestern.com/terms-of-use/" class="text-white"
                             target="_blank">Terms</a></small>
      </div>
   </div>
</footer>
